import { usePermissionService } from 'hooks/iam/permission';
import { useRoleService } from 'hooks/iam/role';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const PermissionsContext = React.createContext({
  is_loading: true,
  permissions: {}
});

export const PermissionsProvider = ({ children }) => {
  const { fetchPermissions } = usePermissionService();
  const { fetchRole } = useRoleService();

  const { tenant_id, memberships } = useSelector((store) => store.user_data);

  const [is_loading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const active_membership = (memberships || []).find(
      (membership) => membership.tenant_id === tenant_id
    );
    if (!active_membership) return;

    const { role_id } = active_membership;
    setIsLoading(true);
    Promise.all([fetchPermissions(), fetchRole(role_id)])
      .then(([{ permissions: all_permissions }, { role }]) => {
        const permissions = role_id === 1 ? all_permissions : role.permissions;
        const parsed_permissions = {};
        permissions.forEach((permission) => {
          const { resource, actions } = permission;
          (actions || []).forEach((action) => {
            const action_name = role_id === 1 ? action : action.name;
            parsed_permissions[`${resource}:${action_name}`] =
              role_id === 1 ? true : action.is_permitted;
          });
        });
        setPermissions(parsed_permissions);
      })
      .finally(setIsLoading(false));
  }, [tenant_id]);

  const value = {
    is_loading,
    permissions
  };
  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};
